import { useRef } from 'react';
import { useIntl } from 'react-intl';
import { DatePicker } from '@mui/x-date-pickers';
import { renderDatePickerLocaleText } from 'utils';
import useEnhancedEffect from '@mui/material/utils/useEnhancedEffect';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-premium';

const GridEditDateCell = ({ id, field, value, hasFocus }: GridRenderEditCellParams<any>) => {
  const intl = useIntl();
  const apiRef = useGridApiContext();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (newValue: unknown) => {
    apiRef.current.setEditCellValue({ id, field, value: newValue });
  };

  useEnhancedEffect(() => {
    if (hasFocus) {
      inputRef.current!.focus();
    }
  }, [hasFocus]);

  return (
    <DatePicker
      value={value}
      onChange={handleChange}
      localeText={renderDatePickerLocaleText(intl)}
      slotProps={{
        textField: {
          inputRef,
          variant: 'standard',
          fullWidth: true,
          size: 'small',
          sx: {
            justifyContent: 'center',
            padding: '0 9px',
          },
          InputProps: {
            sx: { fontSize: 'inherit' },
            disableUnderline: true,
          },
        },
      }}
    />
  );
};

export default GridEditDateCell;
